import { isEmpty, isLowerCase } from 'validations';

export const validateCategory = (category) => {
	let isValid = true;
	let messages = [];

	if (isEmpty(category.name)) {
		isValid = false;
		messages.push('Name is required');
	}

	if (isEmpty(category.value)) {
		isValid = false;
		messages.push('Value is required');
	} else if (!isLowerCase(category.value)) {
		isValid = false;
		messages.push('Value must be in lowercase');
	}

	let validation = {
		isValid,
		messages
	};

	return validation;
};
